export const siteSettings = {
  name: "Global Assets Nest",
  link: "https://globalassetsnest.com",
  email: "support@globalassetsnest.com",
  appLink: "https://app.globalassetsnest.com",
};
